import { render, staticRenderFns } from "./_ProductPriceHover.vue?vue&type=template&id=b3b27e48"
import script from "./_ProductPriceHover.vue?vue&type=script&lang=js"
export * from "./_ProductPriceHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports